import { render } from "./SearchablesHeader.vue?vue&type=template&id=84774ecc"
import script from "./SearchablesHeader.vue?vue&type=script&lang=js"
export * from "./SearchablesHeader.vue?vue&type=script&lang=js"

import "./SearchablesHeader.vue?vue&type=style&index=0&id=84774ecc&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__